<mat-icon class="sg-clear-field" (click)="onClick($event)" matSuffix>close</mat-icon>
